import axios from "axios";
import { ENDPOINTS, getBaseURL } from "data/endpoints";
import { getHeaders } from "data/headers";
import { getDeviceTypeQueryParams } from "utils/device";

export const getInitialSurveyQuestionsApi = (userId: any) => {
  const url = `/users/${userId}${ENDPOINTS.INITIAL_SURVEY}`;
  return axios.get(getBaseURL() + url, {
    headers: getHeaders(),
  });
};

export const submitSurveyProfilerApi = (payload) => {
  // Build request body: use responseText when provided, otherwise answerIds
  const requestBody: any = {
    questionId: payload.questionId,
  };

  if (payload?.responseText !== undefined) {
    requestBody.responseText = payload.responseText;
  } else {
    requestBody.answerIds = payload.answerIds;
  }

  // if (payload?.isLastQuestion !== undefined) {
  //   requestBody.isLastQuestion = payload.isLastQuestion;
  // }

  return axios.post(
    `${getBaseURL()}/users/${payload.userId}/answers/internal`,
    requestBody,
    {
      headers: getHeaders(),
    },
  );
};

export const assignSurveysToUserApi = async (userId: string) => {
  try {
    const { data } = await axios.post(
      getBaseURL() + ENDPOINTS.ASSIGN_SURVEYS_TO_USER,
      { userId },
      {
        headers: getHeaders(),
      },
    );
    return data;
  } catch (e) {
    return {
      message: e.response?.data?.message,
    };
  }
};

export const getSurveyListWithRetryApi = async (
  retries = 3,
  delayMs = 1000,
) => {
  for (let attempt = 1; attempt <= retries; attempt++) {
    try {
      const { data } = await axios.get(
        getBaseURL() +
          ENDPOINTS.USER_SURVEY +
          `?status=Assigned&${getDeviceTypeQueryParams()}`,
        {
          headers: getHeaders(),
        },
      );
      if (
        data &&
        data.response &&
        data.response.rows &&
        data.response.rows.length > 0
      ) {
        window.location.reload();
        return data;
      }
      if (attempt < retries) {
        await new Promise((resolve) => setTimeout(resolve, delayMs));
      }
    } catch (e) {
      if (attempt < retries) {
        await new Promise((resolve) => setTimeout(resolve, delayMs));
      }
    }
  }
  window.location.reload();
  return {
    message: "Failed to fetch surveys after retries",
  };
};
